var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33324 18.6666C5.08093 18.6674 4.83355 18.5967 4.61985 18.4625C4.40614 18.3284 4.23489 18.1364 4.12597 17.9088C4.01706 17.6812 3.97497 17.4273 4.00457 17.1768C4.03418 16.9262 4.13428 16.6892 4.29324 16.4932L17.4932 2.89323C17.5923 2.77893 17.7272 2.7017 17.8759 2.6742C18.0246 2.6467 18.1782 2.67058 18.3115 2.7419C18.4449 2.81322 18.55 2.92775 18.6097 3.0667C18.6694 3.20565 18.68 3.36076 18.6399 3.50656L16.0799 11.5332C16.0044 11.7353 15.9791 11.9526 16.006 12.1666C16.033 12.3806 16.1115 12.5848 16.2347 12.7618C16.3579 12.9388 16.5223 13.0832 16.7136 13.1828C16.9049 13.2823 17.1176 13.3339 17.3332 13.3332H26.6666C26.9189 13.3324 27.1663 13.4031 27.38 13.5373C27.5937 13.6714 27.7649 13.8634 27.8738 14.091C27.9828 14.3186 28.0249 14.5724 27.9952 14.823C27.9656 15.0736 27.8655 15.3106 27.7066 15.5066L14.5066 29.1066C14.4076 29.2208 14.2726 29.2981 14.1239 29.3256C13.9752 29.3531 13.8216 29.3292 13.6883 29.2579C13.5549 29.1866 13.4498 29.072 13.3901 28.9331C13.3305 28.7941 13.3198 28.639 13.3599 28.4932L15.9199 20.4666C15.9954 20.2645 16.0207 20.0472 15.9938 19.8332C15.9668 19.6192 15.8884 19.415 15.7651 19.238C15.6419 19.061 15.4775 18.9165 15.2862 18.817C15.0949 18.7175 14.8822 18.6659 14.6666 18.6666H5.33324Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.79fcfe69f675b00050887dcc5b1c82bd.svg";
export { ForwardRef as ReactComponent };